import React from 'react'
import { useMediaQuery } from 'react-responsive'

import CheckMark from '../Components/CheckMark'

const CardsSection = ({ activeType, currentImages, is_auth = false, t }) => {
    const isMobile = useMediaQuery({ query: '(max-width: 767px)' })
    return (
        <div className="mft-cards-section">
            <div className="mft-cards-section__title">{t(activeType.texts.cardsTitle)}</div>
            {activeType.texts.cards.map((card, ind) => (
                <div
                    className="mft-cards-section__card"
                    key={`mft-card-${ind}`}
                    style={{
                        backgroundColor: activeType.colors.cards[ind],
                    }}
                >
                    <div className="mft-cards-section__card-image">
                        <img src={currentImages.cards[ind]} alt="" />
                    </div>
                    <div className="mft-cards-section__card-description">
                        <CheckMark
                            color={activeType.colors.cards[ind]}
                            bgColor="#FFF"
                            size={isMobile ? 'big' : 'large'}
                        />
                        <div className="mft-cards-section__card-description-title">{t(card.title)}</div>
                        <div className="mft-cards-section__card-description-text">{t(card.description)}</div>
                    </div>
                </div>
            ))}
            <div className="mft-cards-section__tutorial-video">
                <div className="mft-cards-section__tutorial-video-title">{t(activeType.texts.tutorialVideoTitle)}</div>
                <iframe
                    className="mft-cards-section__tutorial-video-iframe"
                    src="https://www.youtube.com/embed/GEWg_9J_9_0"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                />
            </div>
        </div>
    )
}

export default CardsSection
